import { render, staticRenderFns } from "./GoldSchemeList.vue?vue&type=template&id=1128cb1b&scoped=true&"
import script from "./GoldSchemeList.vue?vue&type=script&lang=js&"
export * from "./GoldSchemeList.vue?vue&type=script&lang=js&"
import style0 from "./GoldSchemeList.vue?vue&type=style&index=0&id=1128cb1b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1128cb1b",
  null
  
)

export default component.exports